import { useEffect, useRef } from 'react';

/**
 * Echap ferme la modale du dessus, et seulement elle.
 *
 * Les modales actives forment une pile : la derniere ouverte repond seule a
 * Echap. Un composant qui traite deja Echap (ex. SearchableSelect qui ferme sa
 * liste) appelle preventDefault : la touche est alors ignoree ici, et la
 * modale reste ouverte.
 *
 *   useEscapeKey(onClose, isOpen && !saving);
 */
const stack = [];

const handleKeyDown = (e) => {
  if (e?.key !== 'Escape' || e?.defaultPrevented) return;
  const top = stack[stack.length - 1];
  if (!top) return;
  e.preventDefault();
  top.current?.();
};

const useEscapeKey = (onClose, enabled = true) => {
  const handlerRef = useRef(onClose);
  handlerRef.current = onClose;

  useEffect(() => {
    if (!enabled) return undefined;
    const entry = handlerRef;
    stack.push(entry);
    if (stack.length === 1) document.addEventListener('keydown', handleKeyDown);
    return () => {
      const index = stack.lastIndexOf(entry);
      if (index >= 0) stack.splice(index, 1);
      if (stack.length === 0) document.removeEventListener('keydown', handleKeyDown);
    };
  }, [enabled]);
};

export default useEscapeKey;
